import { combineReducers } from 'redux';

import attachment from './attachmentReducer';
import loadingState from './loadingStateReducer';
import session from './sessionReducer';
import messages from './messagesReducer';
import menu from './menuReducer';


const appReducer = combineReducers({
    attachment,
    loadingState,
    session,
    messages,
    menu,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
